export enum PayType {
  Info = 0,
  Solo = 1,
  Team = 2,
  SoloTeamPay = 3,
  // TeamSoloPay = 4,
  // Training = 5,

  Hourly = 10,
  Daily = 11,

  PnDLocal = 20
}

export const PayTypeMapping: Record<PayType, string> = {
  [PayType.Info]: 'Information',
  [PayType.Solo]: 'Solo',
  [PayType.Team]: 'Team',
  [PayType.SoloTeamPay]: 'Solo (Team Pay)',
  // [PayType.TeamSoloPay]: 'Team(Solo Pay)',
  // [PayType.Training]: 'Training',
  [PayType.Hourly]: 'Hourly',
  [PayType.Daily]: 'Daily',
  [PayType.PnDLocal]: 'P&D Lcl'
};

export const TeamPayTypes: PayType[] = [PayType.Info, PayType.Team];
